<template lang="pug">
  .boleta
    .datos
      .data
        .up
          .big
            .left {{ boleta.nombreMes }} {{ boleta.periodo }}
            .right {{ boleta.descripcionTipo }}
          .big
            .left
              span {{ boleta.codigo }}
              span {{ boleta.nombre }}

          .small
            div
              span Dias trabajados:
              strong {{ boleta.diasTrabajados }}
              br
              span Dias vacaciones:
              strong {{ boleta.diasVacaciones }}
              br
              span Dias subsidio:
              strong {{ boleta.diasSubsidio }}
            div
              span Horas trabajadas:
              strong {{ boleta.horasTrabajadas }}
              br
              span Horas extra:
              strong {{ boleta.horasExtras }}
        .down
          table.table.table-mini.is-bordered
            thead
              th Rubro
              th Ingreso
              th Descuento
              th Aporte
            tbody
              tr(
                v-for="o in boleta.detalle"
              )
                td {{ o.codigoRubro }}  {{ o.descripcionRubro}}
                td.text-align-right
                  template(v-if="o.signo === '+'") {{ o.monto.toFixed(2) }}
                  template(v-else)
                td.text-align-right
                  template(v-if="o.signo === '-'") {{ o.monto.toFixed(2) }}
                  template(v-else)
                td.text-align-right
                  template(v-if="o.signo === ''") {{ o.monto.toFixed(2) }}
                  template(v-else)
              tr
                td.font-bold Totales
                td.font-bold.text-align-right {{ boleta.totalIngresos.toFixed(2) }}
                td.font-bold.text-align-right {{ boleta.totalEgresos.toFixed(2) }}
                td.font-bold.text-align-right {{ boleta.totalAportes.toFixed(2) }}
              tr
                td.font-bold Neto a pagar
                td.font-bold.text-align-right
                td.font-bold.text-align-right
                td.font-bold.text-align-right {{ boleta.montoAPagar.toFixed(2) }}
              tr
                td
                td
              tr
                td.font-bold C.C. Soles
                td.font-bold.text-align-right {{ boleta.cuentaCorrienteSoles.toFixed(2) }}
              tr
                td.font-bold C.C. Dólares
                td.font-bold.text-align-right {{ boleta.cuentaCorrienteDolares.toFixed(2) }}

</template>

<script>
import ConfirmarAccionPositioned from './Component_Confirmar_Accion_Positioned'
export default {
  name: 'boleta-item-transferidos',
  props: ['boleta'],
  data () {
    return {
      showConfirm: false
    }
  },
  components : {
    ConfirmarAccionPositioned
  },
  watch : {
  },
  created () {
  },
  methods: {
    ver () {
      var vm = this
      if (!vm.boleta.visto) {
        // Marcar que lo vio
        vm.$emit('ver', vm.boleta)
      } else {
        vm.$emit('ver', vm.boleta)
      }
    },
    firmar () {
    },
    closeConfirm () {
      this.showConfirm = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .datos
    display flex
    align-items center
  .icon
    width 100px
    color #565cde
    i
      font-size 80px
  .data
    width 300px
  .big
    display flex
    font-size 16px
    .left
      color #a2a2a2
    .right
      padding-left 10px
      color #565cde
  .small
    text-align left
    font-size 12px
    color #cacaca
    margin-top: 2px;
    display flex
    justify-content: space-around;
    span
      display inline-block
      width 100px

  .down
    display flex
    justify-content space-around
    margin-top 10px
    .button
      width 140px
      height 40px



  .disabled
    cursor pointer

  .button-fecha
    display flex
    flex-direction column
    .fecha
      font-size 10px


  .transition
    transition 0.3s all ease

  .table-mini
    font-size: 10px;

  .text-align-right
    text-align right

  .font-bold
    font-weight bold
</style>



// WEBPACK FOOTER //
// Component_Boletas_Item_Transferidos.vue?78c1c9db